// Dữ liệu Thông tin Trang web
export const siteInfo = {
    title: "DevenflyWeb",
    description: "Dịch vụ phát triển, thiết kế và bảo trì WordPress chuyên nghiệp giúp doanh nghiệp của bạn phát triển trực tuyến.",
    phone: "+84 (0) 918 873 984",
    email: "hongducmmo@gmail.com",
    address: "318/47 Phan Văn Trị, Phường 11, Bình Thạnh, TP.HCM, Việt Nam"
};

// Dữ liệu Case Studies
export const caseStudies = [
    {
        id: 1,
        title: "Website Thương mại Điện tử Thời trang",
        client: "StyleHub Boutique",
        description: "Giải pháp thương mại điện tử hoàn chỉnh với tích hợp WooCommerce tùy chỉnh, quản lý kho hàng và xử lý thanh toán.",
        image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        technologies: ["WordPress", "WooCommerce", "Theme Tùy chỉnh", "Cổng Thanh toán", "SEO"],
        results: [
            "Tăng 50% doanh số bán hàng online",
            "Cải thiện 40% tốc độ tải trang",
            "Tăng 25% tỷ lệ chuyển đổi mobile"
        ],
        projectUrl: "#",
        category: "Thương mại điện tử"
    },
    {
        id: 2,
        title: "Website Công ty Marketing Số",
        client: "GrowthMax Agency",
        description: "Website hiện đại cho agency với portfolio showcase, tích hợp blog và form tạo leads.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        technologies: ["WordPress", "Theme Tùy chỉnh", "Contact Form 7", "Yoast SEO", "Analytics"],
        results: [
            "Tăng 75% khách hàng tiềm năng",
            "Cải thiện 60% lưu lượng truy cập tự nhiên",
            "Tăng 35% thời gian phiên trung bình"
        ],
        projectUrl: "#",
        category: "Doanh nghiệp"
    },
    {
        id: 3,
        title: "Hệ thống Quản lý Chuỗi Nhà hàng",
        client: "TasteBud Restaurants",
        description: "Website nhà hàng đa địa điểm với đặt món online, hệ thống đặt bàn và quản lý thực đơn.",
        image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        technologies: ["WordPress", "WooCommerce", "Hệ thống Đặt bàn", "Multi-site", "Plugin Tùy chỉnh"],
        results: [
            "Tăng 90% đơn hàng online",
            "Giảm 45% đơn hàng qua điện thoại",
            "Tăng 30% lượt đặt bàn"
        ],
        projectUrl: "#",
        category: "Nhà hàng"
    },
    {
        id: 4,
        title: "Nền tảng Giáo dục Trực tuyến",
        client: "LearnPro Academy",
        description: "Hệ thống quản lý học tập với tạo khóa học, theo dõi tiến độ học viên và cấp chứng chỉ.",
        image: "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
        technologies: ["WordPress", "LearnDash", "Theme Tùy chỉnh", "Tích hợp Thanh toán", "Chứng chỉ"],
        results: [
            "Tăng 200% số học viên đăng ký",
            "85% tỷ lệ hoàn thành khóa học",
            "95% điểm hài lòng học viên"
        ],
        projectUrl: "#",
        category: "Giáo dục"
    },
    {
        id: 5,
        title: "Portal Phòng khám Y tế",
        client: "MedCare Clinic",
        description: "Portal bệnh nhân với đặt lịch khám, hồ sơ bệnh án và tích hợp khám bệnh từ xa.",
        image: "/project-placeholder.svg",
        technologies: ["WordPress", "Portal Tùy chỉnh", "Hệ thống Đặt lịch", "Tuân thủ HIPAA", "Bảo mật"],
        results: [
            "Tăng 65% lịch hên online",
            "Giảm 40% cuộc gọi hành chính",
            "Cải thiện 50% sự hài lòng bệnh nhân"
        ],
        projectUrl: "#",
        category: "Y tế"
    }
];

// Dữ liệu Bài viết Blog
export const blogPosts = [
    {
        id: 1,
        title: "Plugin WordPress Tốt Nhất Cho SEO Năm 2025",
        excerpt: "Khám phá các plugin SEO WordPress hàng đầu sẽ giúp cải thiện thứ hạng công cụ tìm kiếm và tăng lưu lượng truy cập tự nhiên.",
        image: "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
        author: "Sarah Johnson",
        date: "2025-01-15",
        readTime: "8 phút đọc",
        category: "SEO",
        tags: ["WordPress", "SEO", "Plugin", "Tối ưu hóa"]
    },
    {
        id: 2,
        title: "Cách Tăng Lưu Lượng Website Bằng Content Marketing",
        excerpt: "Học các chiến lược content marketing đã được chứng minh sẽ giúp bạn thu hút nhiều khách truy cập hơn và chuyển đổi họ thành khách hàng trung thành.",
        image: "/content-marketing-placeholder.svg",
        author: "Mike Chen",
        date: "2025-01-10",
        readTime: "12 phút đọc",
        category: "Content Marketing",
        tags: ["Content Marketing", "Lưu lượng", "Chiến lược", "Tăng trưởng"]
    },
    {
        id: 3,
        title: "Thực hành Bảo mật WordPress Tốt Nhất 2025",
        excerpt: "Các biện pháp bảo mật thiết yếu mà mọi chủ sở hữu website WordPress nên triển khai để bảo vệ trang web khỏi hacker và malware.",
        image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
        author: "Jennifer Davis",
        date: "2025-01-05",
        readTime: "10 phút đọc",
        category: "Bảo mật",
        tags: ["WordPress", "Bảo mật", "Thực hành tốt", "Bảo vệ"]
    },
    {
        id: 4,
        title: "WooCommerce vs Shopify: Nền tảng Nào Tốt Hơn 2025?",
        excerpt: "So sánh toàn diện giữa WooCommerce và Shopify để giúp bạn chọn nền tảng thương mại điện tử phù hợp với doanh nghiệp.",
        image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
        author: "Alex Rodriguez",
        date: "2025-01-01",
        readTime: "15 phút đọc",
        category: "Thương mại điện tử",
        tags: ["WooCommerce", "Shopify", "Thương mại điện tử", "So sánh"]
    },
    {
        id: 5,
        title: "Thiết kế Mobile-First: Tại Sao Quan Trọng Với WordPress",
        excerpt: "Hiểu tầm quan trọng của thiết kế mobile-first và cách triển khai hiệu quả trong website WordPress của bạn.",
        image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
        author: "Emma Wilson",
        date: "2024-12-28",
        readTime: "9 phút đọc",
        category: "Thiết kế",
        tags: ["Mobile-First", "Thiết kế", "WordPress", "UX"]
    },
    {
        id: 6,
        title: "Tối ưu Tốc độ Website WordPress Năm 2025",
        excerpt: "Các kỹ thuật và công cụ hàng đầu để cải thiện tốc độ tải trang và hiệu suất tổng thể của website WordPress.",
        image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
        author: "Michael Brown",
        date: "2024-12-25",
        readTime: "8 phút đọc",
        category: "Tối ưu hóa",
        tags: ["Tốc độ", "WordPress", "Tối ưu hóa", "Hiệu suất"]
    },
    {
        id: 7,
        title: "Hướng dẫn Tối ưu Hình ảnh Cho WordPress",
        excerpt: "Cách tối ưu hóa hình ảnh để cải thiện tốc độ trang và trải nghiệm người dùng trên website WordPress của bạn.",
        image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
        author: "Sophia Lee",
        date: "2024-12-20",
        readTime: "7 phút đọc",
        category: "Tối ưu hóa",
        tags: ["Hình ảnh", "WordPress", "Tối ưu hóa", "Hiệu suất"]
    }
];

// Dữ liệu FAQ
export const faqs = [
    {
        id: 1,
        question: "WordPress là gì và tại sao tôi nên chọn nó?",
        answer: "WordPress là hệ thống quản lý nội dung phổ biến nhất thế giới, được sử dụng bởi hơn 40% tất cả các website. Nó linh hoạt, thân thiện với SEO và cung cấp hàng nghìn theme và plugin. WordPress hoàn hảo cho doanh nghiệp mọi quy mô vì có chi phí hiệu quả, có thể mở rộng và dễ quản lý khi được thiết lập đúng cách."
    },
    {
        id: 2,
        question: "Mất bao lâu để xây dựng một website WordPress?",
        answer: "Thời gian phụ thuộc vào độ phức tạp của dự án. Website doanh nghiệp cơ bản thường mất 2-4 tuần, trong khi website thương mại điện tử tùy chỉnh với tính năng nâng cao có thể mất 6-12 tuần. Chúng tôi cung cấp lộ trình chi tiết trong buổi tư vấn ban đầu và cập nhật cho bạn trong suốt quá trình phát triển."
    },
    {
        id: 3,
        question: "Bạn có cung cấp dịch vụ hosting không?",
        answer: "Mặc dù chúng tôi không cung cấp hosting trực tiếp, chúng tôi có thể đề xuất các nhà cung cấp hosting đáng tin cậy và giúp bạn thiết lập tài khoản hosting. Chúng tôi làm việc với nhiều công ty hosting khác nhau và có thể hướng dẫn bạn chọn tùy chọn tốt nhất dựa trên nhu cầu website, kỳ vọng lưu lượng và ngân sách của bạn."
    },
    {
        id: 4,
        question: "Website của tôi có thân thiện với mobile và responsive không?",
        answer: "Hoàn toàn có! Tất cả website WordPress của chúng tôi được xây dựng với nguyên tắc thiết kế mobile-first. Website của bạn sẽ trông tuyệt vời và hoạt động hoàn hảo trên tất cả thiết bị - smartphone, tablet và desktop. Chúng tôi kiểm tra kỹ lưỡng trên các thiết bị và trình duyệt khác nhau để đảm bảo hiệu suất tối ưu."
    },
    {
        id: 5,
        question: "Bạn có thể giúp tối ưu hóa SEO không?",
        answer: "Có, SEO được bao gồm trong tất cả các gói phát triển của chúng tôi. Chúng tôi triển khai các thực hành SEO on-page tốt nhất, tối ưu tốc độ trang, đảm bảo cấu trúc heading đúng, thêm meta tag và thiết lập Google Analytics. Chúng tôi cũng cung cấp dịch vụ SEO liên tục để giúp cải thiện thứ hạng công cụ tìm kiếm theo thời gian."
    },
    {
        id: 6,
        question: "Nếu tôi cần thay đổi sau khi website hoàn thành thì sao?",
        answer: "Chúng tôi cung cấp 30 ngày chỉnh sửa nhỏ miễn phí sau khi ra mắt. Đối với bảo trì và cập nhật liên tục, chúng tôi cung cấp các gói bảo trì hàng tháng bao gồm cập nhật bảo mật, sao lưu, cập nhật nội dung và hỗ trợ kỹ thuật. Chúng tôi luôn sẵn sàng giúp website của bạn phát triển cùng doanh nghiệp."
    },
    {
        id: 7,
        question: "Bạn có thể tích hợp chức năng thương mại điện tử không?",
        answer: "Có, chúng tôi chuyên về tích hợp WooCommerce cho website thương mại điện tử. Chúng tôi có thể thiết lập danh mục sản phẩm, giỏ hàng, cổng thanh toán, quản lý kho hàng và tùy chọn vận chuyển. Dù bạn đang bán sản phẩm vật lý, tải xuống kỹ thuật số hay dịch vụ, chúng tôi có thể tạo một cửa hàng trực tuyến hoàn chỉnh."
    },
    {
        id: 8,
        question: "Bạn có cung cấp đào tạo cách quản lý website không?",
        answer: "Hoàn toàn có! Chúng tôi cung cấp đào tạo toàn diện về cách cập nhật nội dung, thêm trang mới, quản lý blog và sử dụng bảng điều khiển WordPress. Chúng tôi cũng tạo video hướng dẫn tùy chỉnh cụ thể cho website của bạn và cung cấp hỗ trợ liên tục để đảm bảo bạn thoải mái quản lý trang web."
    },
    {
        id: 9,
        question: "Gói bảo trì của bạn bao gồm những gì?",
        answer: "Các gói bảo trì của chúng tôi bao gồm cập nhật WordPress và plugin thường xuyên, giám sát bảo mật, sao lưu hàng ngày, giám sát thời gian hoạt động, tối ưu tốc độ và hỗ trợ ưu tiên. Chúng tôi cũng cung cấp báo cáo hàng tháng về hiệu suất và tình trạng bảo mật website của bạn."
    },
    {
        id: 10,
        question: "Bạn có thể di chuyển website hiện tại của tôi sang WordPress không?",
        answer: "Có, chúng tôi cung cấp dịch vụ di chuyển website từ nhiều nền tảng khác nhau bao gồm Wix, Squarespace, Shopify và các trang HTML tùy chỉnh. Chúng tôi xử lý toàn bộ quá trình di chuyển, đảm bảo nội dung, hình ảnh và thứ hạng SEO được bảo tồn. Việc di chuyển bao gồm chuyển hướng URL và kiểm tra kỹ lưỡng."
    }
];

// Dữ liệu Dịch vụ
export const services = [
    {
        id: 1,
        title: "Thiết kế website WordPress",
        longDescription: "Chúng tôi thiết kế website WordPress hiện đại, tối ưu trải nghiệm người dùng, chuẩn SEO và sẵn sàng mở rộng. Mỗi dự án đều dựa trên phân tích hành vi khách hàng và mục tiêu kinh doanh để tăng chuyển đổi.",
        extraFeatures: [
            "Tư vấn cấu trúc thông tin",
            "Thiết kế landing page chuyển đổi cao",
            "Tối ưu Core Web Vitals",
            "Thiết lập tracking (GA4, GSC)",
            "Tích hợp form & CRM"
        ],
        description: "Thiết kế giao diện chuyên nghiệp, tối ưu trải nghiệm người dùng trên nền tảng WordPress.",
        icon: "wordpress",
        features: [
            "Thiết kế chuẩn UX/UI",
            "Responsive đa thiết bị",
            "Tối ưu tốc độ tải",
            "Cấu trúc chuẩn SEO",
            "Tích hợp thương hiệu"
        ]
    },
    {
        id: 2,
        title: "Thiết kế website customize từ đầu",
        longDescription: "Giải pháp custom build từ đầu cho doanh nghiệp cần sự khác biệt và hiệu năng cao. Code sạch, tách lớp rõ ràng, dễ bảo trì, tối ưu bảo mật và khả năng mở rộng lâu dài.",
        extraFeatures: [
            "Phân tích yêu cầu chi tiết",
            "Thiết kế hệ thống design system",
            "Module hóa chức năng",
            "Chuẩn bị môi trường staging",
            "Tích hợp API bên thứ 3"
        ],
        description: "Phát triển giao diện & chức năng theo yêu cầu, không giới hạn bởi theme sẵn có.",
        icon: "customize",
        features: [
            "Phân tích & tư vấn giải pháp",
            "Thiết kế UI/UX độc quyền",
            "Code tối ưu hiệu suất",
            "Bảo mật nâng cao",
            "Khả năng mở rộng dài hạn"
        ]
    },
    {
        id: 3,
        title: "Phát hành & tối ưu vận hành",
        longDescription: "Triển khai nhanh chóng, chuẩn hoá hạ tầng và bảo mật ngay từ đầu. Chúng tôi tối ưu cấu hình server, cache, bảo mật, backup và giám sát.",
        extraFeatures: [
            "Cấu hình server / hosting tối ưu",
            "Thiết lập CDN / SSL",
            "Thiết lập caching (Object + Page)",
            "Hardening bảo mật cơ bản",
            "Thiết lập backup tự động"
        ],
        icon: "deploy",
        description: "Thiết lập hạ tầng, cấu hình WordPress và tối ưu vận hành ban đầu.",
        features: [
            "Cài đặt hosting/domain",
            "Cấu hình bảo mật cơ bản",
            "Tối ưu cache & tốc độ",
            "Tích hợp plugin cần thiết",
            "Bàn giao & hướng dẫn sử dụng"
        ]
    },
    {
        id: 4,
        title: "Bảo trì, quản trị web",
        longDescription: "Dịch vụ bảo trì toàn diện giữ website an toàn, nhanh và ổn định. Chủ động phát hiện sự cố, tối ưu định kỳ và hỗ trợ xử lý nhanh chóng.",
        extraFeatures: [
            "Giám sát uptime real-time",
            "Quét malware & hardening",
            "Tối ưu database định kỳ",
            "Báo cáo hiệu suất hàng tháng",
            "Tối ưu SEO kỹ thuật liên tục"
        ],
        description: "Theo dõi, cập nhật và đảm bảo website vận hành ổn định & an toàn.",
        icon: "maintenance",
        features: [
            "Cập nhật core & plugin",
            "Sao lưu định kỳ",
            "Giám sát uptime & bảo mật",
            "Tối ưu hiệu suất định kỳ",
            "Hỗ trợ xử lý sự cố"
        ]
    }
];

// Dữ liệu Gói Giá
// Danh mục tính năng chuẩn hóa để so sánh (key -> label)
export const featureCatalog = [
    { key: 'core_about', label: 'Trang giới thiệu doanh nghiệp chuẩn SEO' },
    { key: 'blog_basic', label: 'Trang tin tức / blog cơ bản' },
    { key: 'contact_form_basic', label: 'Form liên hệ gửi email' },
    { key: 'basic_service_listing', label: 'Hiển thị thông tin dịch vụ / sản phẩm cơ bản' },
    { key: 'admin_easy_layout', label: 'Trang quản trị nội dung chi tiết' },
    { key: 'layout_custom_blocks', label: 'Tùy chỉnh bố cục các khối nội dung' },
    { key: 'contact_form_advanced', label: 'Form liên hệ mở rộng (nhiều trường)' },
    { key: 'analytics_fanpage', label: 'Tích hợp thống kê & fanpage' },
    { key: 'catalog_products', label: 'Danh mục & trang chi tiết sản phẩm' },
    { key: 'cart_checkout', label: 'Giỏ hàng, quy trình đặt hàng & quản lý đơn hàng' },
    { key: 'inventory_basic', label: 'Quản lý tồn kho cơ bản' },
    { key: 'order_email_notifications', label: 'Email doanh nghiệp / thông báo đơn hàng' },
    { key: 'payment_information', label: 'Cấu hình thông tin thanh toán (qua ngân hàng)' },
    { key: 'product_conversion_opt', label: 'Tối ưu chuyển đổi trang sản phẩm' },
    { key: 'brand_custom_design', label: 'Thiết kế độc quyền theo brand guideline' },
    { key: 'performance_advanced', label: 'Tối ưu hiệu năng nâng cao (cache layers)' },
    { key: 'custom_modules', label: 'Module mở rộng tùy chỉnh' },
    { key: 'industry_ux_process', label: 'Quy trình UX dành riêng cho ngành' },
    { key: 'role_permissions', label: 'Phân quyền quản trị chi tiết' },
    { key: 'system_architecture_consult', label: 'Phân tích & tư vấn kiến trúc hệ thống riêng' },
    { key: 'third_party_integrations', label: 'Tích hợp API / dịch vụ bên thứ 3' },
    { key: 'deep_business_modules', label: 'Module nghiệp vụ tùy chỉnh sâu' },
    { key: 'staging_testing_flow', label: 'Quy trình kiểm thử & staging riêng' },
    { key: 'scaling_infrastructure', label: 'Mở rộng hạ tầng / scaling theo yêu cầu' },
    { key: 'promotion_coupons', label: 'Chương trình khuyến mãi & mã giảm giá' },
];

export type PricingPlan = {
    id: number;
    name: string;
    price: number | null;
    priceType: string;
    description: string;
    maintenance?: Record<string, any>;
    benefits?: Record<string, any>;
    audience?: string;
    template?: string;
    languages?: string;
    integrations?: string[];
    timeline?: string;
    featureAdditions?: string[];
    features?: string[];
    promotions?: string[];
    domain?: string | null;
    hosting?: string;
    warranty?: string;
    popular?: boolean;
    buttonText?: string;
    buttonAction?: string;
    period?: string;
};

export const pricingPlans: PricingPlan[] = [
    {
        id: 1,
        name: "Standard",
        price: 2490000,
        priceType: "one-time",
        description: "Doanh nghiệp vừa và nhỏ giới thiệu thông tin.",
        maintenance: {
            domain: { includedYears: 0, annualFee: 330000, note: "Không kèm domain mặc định" },
            hosting: { includedYears: 1, annualFee: 800000, startFromYear: 2, highlight: true },
            support: { includedMonths: 12, afterAnnualFee: 500000, scope: "Cập nhật core/plugin, giám sát uptime cơ bản" }
        },
        benefits: {
            banners: 2,
            dataEntryItems: 10,
            ssl: false,
            freeDomain: false,
            sourceCode: false,
            warrantyMonths: 12
        },
        audience: "Doanh nghiệp vừa và nhỏ, tập trung giới thiệu thông tin doanh nghiệp.",
        template: "Sử dụng mẫu giao diện dựng sẵn",
        languages: "1 ngôn ngữ (Tiếng Việt)",
        integrations: [
            "Chat online",
            "Tương thích mọi trình duyệt & thiết bị",
            "Tối ưu hóa SEO"
        ],
        timeline: "7 ngày",
        featureAdditions: [
            'core_about',
            'blog_basic',
            'contact_form_basic',
            'basic_service_listing'
        ],
        promotions: [
            "Tặng 2 banner",
            "Miễn phí nhập liệu 10 bài viết / sản phẩm",
            "Hosting 1GB / 50GB băng thông (gia hạn năm 2: 800.000đ/năm)",
            "Bảo hành 12 tháng"
        ],
        domain: null,
        hosting: "1GB / 50GB bandwidth",
        warranty: "12 tháng",
        popular: false,
        buttonText: "Chọn gói",
        buttonAction: "contact"
    },
    {
        id: 2,
        name: "Professional",
        price: 4490000,
        priceType: "one-time",
        description: "Giới thiệu doanh nghiệp & sản phẩm e-catalog.",
        maintenance: {
            domain: { includedYears: 1, annualFee: 330000, startFromYear: 2 },
            hosting: { includedYears: 1, annualFee: 1500000, startFromYear: 2, highlight: true },
            support: { includedMonths: 24, afterAnnualFee: 1000000, scope: "Giám sát bảo mật, backup tháng, tối ưu hiệu suất định kỳ" }
        },
        benefits: {
            banners: 3,
            dataEntryItems: 20,
            ssl: true,
            freeDomain: true,
            sourceCode: true,
            warrantyMonths: 24
        },
        audience: "Doanh nghiệp và cửa hàng cần giới thiệu doanh nghiệp và sản phẩm dạng e-catalog.",
        template: "Mẫu giao diện dựng sẵn (có chỉnh sửa)",
        languages: "1 ngôn ngữ (Tiếng Việt)",
        integrations: [
            "Chat online",
            "Tương thích mọi trình duyệt & thiết bị",
            "Tối ưu hóa SEO",
            "Công cụ SEO",
            "Kết nối fanpage",
            "Thống kê truy cập",
            "Bình luận bài viết"
        ],
        timeline: "14-21 ngày",
        featureAdditions: [
            'admin_easy_layout',
            'layout_custom_blocks',
            'contact_form_advanced',
            'analytics_fanpage',
            'catalog_products',
        ],
        promotions: [
            "Tặng 3 banner",
            "Miễn phí nhập liệu 20 bài viết / sản phẩm",
            "Miễn phí SSL",
            "Miễn phí năm đầu Domain quốc tế (.com/.net) (gia hạn năm 2: 330.000đ/năm)",
            "Hosting 2GB băng thông không giới hạn (gia hạn từ năm 2: 1.500.000đ/năm)",
            "Bàn giao mã nguồn",
            "Bảo hành 24 tháng"
        ],
        domain: ".com / .net",
        hosting: "2GB / Unlimited bandwidth",
        warranty: "24 tháng",
        popular: true,
        buttonText: "Phổ biến",
        buttonAction: "contact"
    },
    {
        id: 3,
        name: "Advanced",
        price: 7490000,
        priceType: "one-time",
        description: "Website bán hàng trực tuyến.",
        maintenance: {
            domain: { includedYears: 1, annualFee: 330000, startFromYear: 2 },
            hosting: { includedYears: 1, annualFee: 1900000, startFromYear: 2, highlight: true },
            support: { includedMonths: 36, afterAnnualFee: 1000000, scope: "WooCommerce updates, backup tháng, bảo mật nâng cao, tối ưu Cumulative Layout Shift" }
        },
        benefits: {
            banners: 3,
            dataEntryItems: 30,
            ssl: true,
            freeDomain: true,
            sourceCode: true,
            warrantyMonths: 36
        },
        audience: "Doanh nghiệp cần website bán hàng trực tuyến với quản lý sản phẩm và giỏ hàng.",
        template: "Chọn mẫu giao diện (có chỉnh sửa)",
        languages: "1 ngôn ngữ (Tiếng Việt)",
        integrations: [
            "Chat online",
            "Tương thích mọi trình duyệt & thiết bị",
            "Tối ưu hóa SEO",
            "Công cụ SEO",
            "Kết nối fanpage",
            "Thống kê truy cập",
            "Bình luận bài viết",
            "Email doanh nghiệp"
        ],
        timeline: "21-30 ngày",
        featureAdditions: [
            'cart_checkout',
            'order_email_notifications',
            'promotion_coupons',
        ],
        promotions: [
            "Tặng 3 banner",
            "Miễn phí nhập liệu 30 bài viết / sản phẩm",
            "Miễn phí SSL",
            "Miễn phí năm đầu Domain quốc tế (.com/.net) (gia hạn năm 2: 330.000đ/năm)",
            "Hosting 3GB băng thông không giới hạn (gia hạn từ năm 2: 1.900.000đ/năm)",
            "Bàn giao mã nguồn",
            "Bảo hành 36 tháng"
        ],
        domain: ".com / .net",
        hosting: "3GB / Unlimited bandwidth",
        warranty: "36 tháng",
        popular: false,
        buttonText: "Chọn gói",
        buttonAction: "contact"
    },
    {
        id: 4,
        name: "Customizer",
        price: 11490000,
        priceType: "one-time",
        description: "Website thanh toán trực tuyến thiết kế độc quyền.",
        maintenance: {
            domain: { includedYears: 1, annualFee: 330000, startFromYear: 2 },
            hosting: { includedYears: 1, annualFee: 2750000, startFromYear: 6, highlight: true },
            support: { includedMonths: 60, afterAnnualFee: 1000000, scope: "Hiệu năng nâng cao, backup tháng, bảo mật nhiều lớp, giám sát real-time" }
        },
        benefits: {
            banners: 5,
            dataEntryItems: 50,
            ssl: true,
            freeDomain: true,
            sourceCode: true,
            warrantyMonths: 60
        },
        audience: "Doanh nghiệp cần website thanh toán trực tuyến, thiết kế độc quyền.",
        template: "Thiết kế giao diện độc quyền",
        languages: "2 ngôn ngữ (Việt & Anh)",
        integrations: [
            "Chat online",
            "Tương thích mọi trình duyệt & thiết bị",
            "Tối ưu hóa SEO",
            "Công cụ SEO",
            "Kết nối fanpage",
            "Thống kê truy cập",
            "Bình luận bài viết",
            "Email doanh nghiệp"
        ],
        timeline: "30-45 ngày",
        featureAdditions: [
            'brand_custom_design',
            'performance_advanced',
            'custom_modules',
            'industry_ux_process',
            'role_permissions'
        ],
        promotions: [
            "Tặng 5 banner",
            "Miễn phí nhập liệu 50 bài viết / sản phẩm",
            "Miễn phí SSL",
            "Miễn phí năm đầu Domain (.com/.net/.vn/.com.vn) (gia hạn năm 2: 330.000đ/năm)",
            "Hosting 5GB băng thông không giới hạn (gia hạn từ năm 2: 2.750.000đ/năm)",
            "Bàn giao mã nguồn",
            "Bảo hành 60 tháng"
        ],
        domain: ".com / .net / .vn / .com.vn",
        hosting: "5GB / Unlimited bandwidth",
        warranty: "60 tháng",
        popular: false,
        buttonText: "Chọn gói",
        buttonAction: "contact"
    },
    {
        id: 5,
        name: "Extra",
        price: null,
        priceType: "custom",
        description: "Yêu cầu đặc thù nâng cao.",
        maintenance: {
            domain: { includedYears: 1, annualFee: null, note: "Theo yêu cầu" },
            hosting: { includedYears: 1, annualFee: null, note: "Theo hạ tầng riêng" },
            support: { includedMonths: 60, afterAnnualFee: null, scope: "Theo SLA tùy chỉnh" }
        },
        benefits: {
            banners: 5,
            dataEntryItems: 50,
            ssl: true,
            freeDomain: true,
            sourceCode: true,
            warrantyMonths: 60
        },
        audience: "Doanh nghiệp có yêu cầu đặc thù về giao diện, chức năng và cấu trúc.",
        template: "Thiết kế độc quyền theo yêu cầu",
        languages: "2+ ngôn ngữ",
        integrations: [
            "Chat online",
            "Tương thích mọi trình duyệt & thiết bị",
            "Tối ưu hóa SEO",
            "Công cụ SEO",
            "Kết nối fanpage",
            "Thống kê truy cập",
            "Bình luận bài viết",
            "Email doanh nghiệp",
            "Tính năng tùy chỉnh theo yêu cầu"
        ],
        timeline: "Phụ thuộc yêu cầu",
        featureAdditions: [
            'system_architecture_consult',
            'third_party_integrations',
            'deep_business_modules',
            'staging_testing_flow',
            'scaling_infrastructure'
        ],
        promotions: [
            "Tặng 5 banner",
            "Miễn phí nhập liệu 50 bài viết / sản phẩm",
            "Miễn phí SSL",
            "Miễn phí năm đầu Domain (.com/.net/.vn/.com.vn) (gia hạn năm 2: 330.000đ/năm)",
            "Hosting 5GB băng thông không giới hạn (gia hạn từ năm 2: 2.750.000đ/năm)",
            "Bàn giao mã nguồn",
            "Bảo hành 60 tháng"
        ],
        domain: ".com / .net / .vn / .com.vn",
        hosting: "5GB / Unlimited bandwidth",
        warranty: "60 tháng",
        popular: false,
        buttonText: "Liên hệ báo giá",
        buttonAction: "contact"
    }
];

// Dữ liệu Thành viên Đội ngũ
export const teamMembers = [
    {
        id: 1,
        name: "Sarah Johnson",
        role: "Trưởng nhóm Phát triển WordPress",
        image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80",
        bio: "Hơn 5 năm kinh nghiệm phát triển WordPress với chuyên môn về theme tùy chỉnh và giải pháp thương mại điện tử."
    },
    {
        id: 2,
        name: "Mike Chen",
        role: "Chuyên gia SEO",
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80",
        bio: "Chuyên gia marketing số chuyên về SEO WordPress và tối ưu hiệu suất."
    },
    {
        id: 3,
        name: "Jennifer Davis",
        role: "Thiết kế UI/UX",
        image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80",
        bio: "Nhà thiết kế sáng tạo tập trung vào trải nghiệm người dùng và tối ưu chuyển đổi cho website WordPress."
    }
];
